const messages = {
  homevall:{
    homevall1: "邀請",
    homevall2: "已連接",
    homevall3: "連接",
    homevall4: "首頁",
    homevall5: "市場",
    homevall6: "挖礦",
    homevall7: "邀請",
    homevall8: "連接成功",
    homevall9: "連接失敗",
    homevall10: "確認綁定",
    homevall11: "取消",
    homevall12_1: "質押借貸",
    homevall12_2: "寵物世界",
    homevall12_3: "體育競技",
    homevall12_4: "確認",
    homevall12_5: "遊戲娛樂",
    swap: "閃兌",
    referInputPlaceholder: "輸入推薦人地址",
    invalidAddress: "無效的地址",
    cannotReferSelf: "不能將自己設為推薦人",
    referNeedsRefer: "該推薦人需要自己也有推薦人",
    bindSuccess: "綁定成功",
    bindFailed: "綁定失敗",
    bindReferError: "綁定推薦人失敗",
    checkReferralError: "檢查推薦人狀態失敗"
  },
  home: {
    home1: "挖礦年利率",
    home2: "存款",
    home3: "輸入兌換金額",
    home4: "帳戶餘額",
    home5: "兌換金額",
    home6: "立即兌換",
    home7: "挖礦算力",
    home8: "挖礦年利率",
    home9: "激活",
    home10: "礦床",
    home11: "DBTC挖礦總產出",
    home12: "淨收益率",
    home13: "已產出",
    home14: "剩餘",
    home15: "總額度",
    home16: "總算力",
    home17: "挖礦代幣",
    home18: "單幣貨幣",
    home19: "所有貨幣",
    home20: "LP貨幣",
    home21: "選擇代幣",
    home22: "貨幣",
    home23: "挖礦收益",
    home32: "查看ninja報告",
    home323: "查看certik報告",
    home33: "數據",
    home34: "未開放",
    home35: "詳情",
    home36: "直接銷毀比例",
    home37: "增加流動性比例",
    home38: "項目方比例",
    home39: "購買DBTC銷毀比例",
    home40: "授權成功",
    home41: "授權失敗",
    home42: "請輸入",
    home43: "存入成功",
    home44: "存入失敗",
    home45: "請鏈接錢包",
    home46: "占未开通",
    home47:"存入代币价值要大于110 USDT",
    home48:"存入代币数量大于钱包数量！",
    copySuccess:"複製成功"
  },
  bazaar: {
    bazaar1: "全網质押金额",
    bazaar2: "所有市場",
    bazaar3: "貨幣",
    bazaar4: "總存款",
    bazaar5: "质押率",
    bazaar6: "流動性",
    bazaar7: "存款利率",
    bazaar8: "抵押因子",
    bazaar9: "存款排名",
    bazaar10: "查看安全報告",
    bazaar11: "通過知名稽核公司certik/cfg.ninja安全稽核"
  },
    ore:{
      ore1: "全網總算力",
      ore2: "全網剩餘產出DBTC總量",
      ore3: "全網每日算力",
      ore4: "全網每日產出DBTC總量",
      ore5: "當前每日產出",
      ore6: "我的總算力",
      ore7: "存款算力",
      ore8: "待領取",
      ore9: "領取",
      ore10: "已領取",
      ore11: "個人算力排行榜",
      ore12: "封神榜",
      ore13: "全網累計分紅",
      ore14: "待領取分紅",
      ore15: "排行榜前10名有機會獲得手續費分紅",
      ore16: "排名",
      ore17: "地址",
      ore18: "算力",
      ore19: "占比",
      ore20: "邀請朋友參與購買和賺取NFT",
      ore21: "團隊存款",
      ore22: "領取記錄",
      ore23: "我的推薦算力",
      ore24: "產生算力後的第二天開始產出，持續30天",
      ore25: "今日算力因子",
      ore26: "無可領取",
      ore27: "領取成功",
      ore28: "私募算力",
      ore29: '今日開盤價格',
      ore30: '漲幅',
      ore31: '當前價格',

    },
  my:{
    my1: "邀請好友",
    my2: "贏高額算力",
    my3: "您已獲得的算力",
    my4: "您的邀請人",
    my5: "複製邀請鏈接",
    my6: "您邀請的人",
    my7: "展開",
    my8: "收起",
    my9: "排名",
    my10: "地址",
    my11: "占比",
    my12: "人",
    my13: "算力",
    my14: "未激活算力",
    my15: "已經激活推薦算力"

  },
  record:{
    record1:'领取记录',
    record2: '當日算力產出',
    record3:'当日存款算力',
  },
  swap: {
    sell: "出售",
    buy: "購買",
    balance: "餘額",
    price: "價格",
    slippage: "滑點",
    exchange: "闪兌",
    approve: "授權",
    bestPrice: "價格",
    enterAmount: "输入数量",
    insufficientApproval: "您尚未授權足夠的DBTC",
    exchangeSuccess: "兌換成功",
    exchangeFail: "兌換失敗",
    approveSuccess: "授權成功",
    approveFail: "授權失敗",
    bestPriceError: "獲取價格失敗",
    fixedRate: "",
    notEnoughAllowance: "授權額度不足",
    invalidAmount: "請輸入有效數量"
  }
}

export default messages
